export type AuthKey = string;
export type HexColor = string;
export type ISO8601 = string; // e.g. "2017-11-03T13:17:03Z"

/*
 * UnixTime in Seconds
 */
export type UnixTimestamp = string;
export type JSONString = string;
export type MECSSectorCode = string; // a string that starts with "MECS:" e.g. "MECS:201"
export type Milliseconds = number;
export type Seconds = number;
export type StringNumber = string; // a string that only contains numbers
export type URLString = string;

export type UUID = string | '';
/*
 * system
 */
export interface Params {
  [key: string]: string | number | boolean | undefined | null;
}

// ---------------------------------- TODO THROW AWAY ----------------------------------

export enum CookiesKey {
  benzingaToken = 'benzinga_token',
  runtimeEnv = 'runtime-env',
}

export enum StorageKey {
  activeChannelId = 'activeChannelId',

  // session keys
  authKey = 'authKey',
  // notification
  bzNotificationIgnore = 'bzNotificationIgnore',
  // deprecated categories helpers
  deprecatedCategories = 'deprecatedCategories',

  // Popout keys
  fetchWatchlists = 'fetchWatchlists',
  fingerprint = 'fingerprint',

  hasLoadedCategories = 'hasLoadedCategories',
  lastLoadedLayoutId = 'lastLoadedLayoutId',
  // Layout keys
  lastSendLayoutTime = 'lastSendLayoutTime',
  layout = 'layout',
  layoutId = 'layoutId',

  layoutVersion = 'layoutVersion',
  popoutCachedState = 'popoutCachedState',

  popoutDataTransfer = 'popoutDataTransfer',
  popoutUpdate = 'popoutUpdate',
  sessionExpired = 'sessionExpired',
  theme = 'theme',

  // TradeInfoKeys
  tradeInfo = 'tradeInfo',
}

export enum PersistStorageKey {
  chat = 'persist:chat',
  popoutWidgetsById = 'persist:widgetsById-popout',
  scannerConfigs = 'persist:scannerConfigs',
  settings = 'persist:settings',
  sources = 'persist:sources',
  watchlists = 'persist:watchlists',
  watchlistsById = 'persist:watchlistsById',
  widgetsById = 'persist:widgetsById',
  widgets = 'persist:widgets',
  initialized = 'persist:initialized',
  layoutVersion = 'persist:layoutVersion',
  workspaces = 'persist:workspaces',
  workspacesById = 'persist:workspacesById',
  activeLayoutId = 'persist:activeLayoutId',
  lastUsedSavedLayout = 'lastUsedSavedLayout',
  morningReportFilters = 'persist:morningReportFilters',
  topStories = 'persist:topStories',
}
export enum SessionStorageKey {
  activeChannelId = 'activeChannelId',
  // notification
  bzNotificationIgnore = 'bzNotificationIgnore',
  // deprecated categories helpers
  deprecatedCategories = 'deprecatedCategories',
  hasLoadedCategories = 'hasLoadedCategories',
  // Layout keys
  pastedLayout = 'pastedLayout',
  // theme
  theme = 'theme',
  // TradeInfoKeys
  tradeInfo = 'tradeInfo',
}

export enum LocalStorageKey {
  permissions = 'permissions',
  /** Must match `User.id` for `permissions` to be applied (avoids cross-account leakage). */
  permissionsOwnerId = 'permissionsOwnerId',
  activeChannelId = 'activeChannelId',
  // session keys
  authKey = 'authKey',
  sessionExpired = 'sessionExpired',
  // watchlist keys
  fetchWatchlists = 'fetchWatchlists',
  // Popout keys
  fingerprint = 'fingerprint',
  popoutCachedState = 'popoutCachedState',
  popoutDataTransfer = 'popoutDataTransfer',
  popoutUpdate = 'popoutUpdate',
  navChromeSnapshot = 'bz-nav-chrome-snapshot',
}

/**
 * Cleared on logout only. Does not touch layouts, widgets, or other prefs.
 * Main session token is cookie `benzinga_token`, not localStorage.
 */
export const LOCAL_STORAGE_KEYS_CLEARED_ON_LOGOUT: readonly string[] = [
  LocalStorageKey.permissions,
  LocalStorageKey.permissionsOwnerId,
  'sessionExpired',
  'fingerprint',
  'adlight',
  /** BZ / India login role flags */
  'editorial/edit',
  'cms/role_contributor',
  /** Legacy session / watchlist flags (fission LocalStorageKey) */
  'fetchWatchlists',
  'WATCHLIST_SYMBOLS',
  LocalStorageKey.navChromeSnapshot,
];
